module.exports = __webpack_public_path__ + "static/media/main-visual-01-m.17ffad6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/main-visual-01-m.mp4
// module id = gTZM
// module chunks = 1